<template>
    <div class="search-criteria-page">
        <div class="action-buttons text-end">
            <!-- EXPORT -->
            <button class="button-with-svg widget-button widget-accent-button widget-button-share w-auto "
                @click.prevent="initExport()"
                v-if="$route.name !== 'charts' && $route.name !== 'matchmaker-pos'"
                data-toggle="modal" data-target="#exportModal"
                :disabled="!hasData"
                :class="{'disabled': !hasData}">
                    <span class="btn-text">Export</span>
                    <div class="loader export-loader" v-if="isExportingFile"></div>
					<i class="fas fa-download widget-button-icon"></i>
            </button>
            <div class="btn-group widget-button-dataset" v-else-if="$route.name === 'charts'">
                <button class="button-with-svg widget-button widget-accent-button widget-button-share" id="dropdownMenuSummaryBy" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="btn-text">Export</span>
					<i class="fas fa-download widget-button-icon"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuSummaryBy" v-if="$route.name === 'charts'">
                    <a class="dropdown-item"  href @click.prevent="exportData('chart')" rel="noopener">Export Chart As Image</a>
                    <a class="dropdown-item" href @click.prevent="exportData('table')" rel="noopener">Export Data As CSV</a>
                </div>
            </div>

        </div>
        <div class="search-criteria-section" >
            <!-- DISCLAIMER -->
            <div v-if="isMissingCriteria" class="disclaimer">
                Criteria for this search is no longer available. The Matchmaker system does not track and store submitted text.
            </div>
            <!-- SEARCH CRITERIA -->
            <div v-else class="matchmaker-search">
                <label class="field-title" for="matchmakerSearch" v-if="showTitle">Matchmaker Search</label>
                <textarea
                    type="text"
                    class="form-control form-control-lg input-text__input"
                    aria-label="Matchmaker Search"
                    aria-describedby="matchmaker-search-btn"
                    id="matchmakerSearch"
                    ref="input"
                    v-model="$store.state.searchCriteria['matchmaker_text']"
                    rows="3"
                    placeholder="Abstracts & Other Scientific Text"
                    maxLength="15000"
                ></textarea>
                <button
                    class="btn btn-primary btn-lg"
                    type="button"
                    id="matchmaker-search-btn"
                    @click.prevent="search(true, true)"
                    :disabled="isSearchingMatchmaker"
                >
                    Search
                    <div class="loader" v-if="isSearchingMatchmaker"></div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import bus from '@/shared/event-bus.js';
import { HttpStatusCode } from 'axios';

export default {
    name: 'matchmakerCriteria',
    watch:{
        criteriaStr: function (val) {
            this.$nextTick(() => {
                var criteriaTextObj = document.getElementById('criteriaContainer'),
                    showMoreLinkObj = document.getElementById('viewMore');

                if (showMoreLinkObj) {
                    if (criteriaTextObj && criteriaTextObj.clientHeight + 5 < criteriaTextObj.scrollHeight) {
                        showMoreLinkObj.classList.add('display-link');
                        showMoreLinkObj.parentNode.classList.add('new-line');
                    } else {
                        criteriaTextObj.classList.add('expanded');
                        showMoreLinkObj.classList.remove('display-link');
                        showMoreLinkObj.parentNode.classList.remove('new-line');
                    }
                }
            });
        }
    },
    computed: {
        ...mapGetters([
            'searchCriteria',
            'searchType',
            'isExportingFile',
            'externalURLs'
        ]),
        hasData: function () {
            switch (this.$route.name) {
                case 'matchmaker-projects':
                    if (this.$store.state.matchmakerResults && this.$store.state.matchmakerResults.results && this.$store.state.matchmakerResults.results.length > 0) {
                        return true;
                    }
                    break;
            }
            return false;
        }
    },
    data: function () {
        return {
            showHelpText: false,
            error: false,
            showTitle: false,
            serverless: false,
            data: null,
            showCriteria: false,
            showHideLinkText: 'More',
            searchFieldSpecs: window.searchFieldSpecs,
            criteriaStr: '',
            localStorageCriteria: null,
            isSearchingMatchmaker: false,
            isMissingCriteria: false
        };
    },
    mounted () {
        if ((this.searchMeta && !this.searchMeta.search_id) || !this.$route.params.search_id) {
            this.$router.push({ path: '/' }).catch(err => {});
        } else {
            this.showCriteria = false;
            if (!this.$parent.matchmakerResults) {
                if (this.$route.params.search_id) {
                    this.localStorageCriteria = localStorage.getItem('matchmakerSearchText' + this.$route.params.search_id);

                    if (this.localStorageCriteria) {
                        this.criteriaStr = this.localStorageCriteria;
                        this.$store.state.searchCriteria['matchmaker_text'] = this.criteriaStr;
                    }
                } else {
                    // Instead of getting matchmaker criteria, show disclaimer
                    this.isMissingCriteria = true;
                    // this.$parent.getSearchCriteria();
                }
            }

            if (!this.localStorageCriteria) {
                this.criteriaStr = '';
                this.criteriaStr = this.buildCriteria();
            }
        }

        this.setFullscreen(true);

        document.addEventListener('keydown', this.handleInputEvent);
    },
    destroyed () {
        document.removeEventListener('keydown', this.handleInputEvent);
    },
    methods: {
        ...mapActions([
            'setFullscreen',
            'setEditSearchResultsFlag',
            'setLookup',
            'setSearchMode',
            'setSearchType',
            'setExportCriteria',
            'setSearchMeta',
            'setMatchmakerResults',
        ]),
        initExport () {
            bus.$emit('export:init');
        },
        isEmpty (obj) {
            // null and undefined are "empty"
            if (obj == null) return true;

            // Assume if it has a length property with a non-zero value
            // that that property is correct.
            if (obj.length > 0)    return false;
            if (obj.length === 0)  return true;

            // If it isn't an object at this point
            // it is empty, but it can't be anything *but* empty
            // Is it empty?  Depends on your application.
            if (typeof obj !== "object") return true;

            // Otherwise, does it have any properties of its own?
            // Note that this doesn't handle
            // toString and valueOf enumeration bugs in IE < 9
            for (var key in obj) {
                if (hasOwnProperty.call(obj, key)) return false;
            }

            return true;
        },
        buildCriteria () {
            var tempCriteria = this.$store.state.searchCriteria,
                htmlStr = '',
                criteriaJSON = {};

            // if (this.$store.state.editSearchResults) {
            //     tempCriteria = this.$store.state.editSearchCriteria;
            // }

            if (tempCriteria.matchmaker_text) {
                if (typeof tempCriteria.matchmaker_text === 'string') {
                    htmlStr += '<span class="criteria"><span class="title">Search Text:</span> <span>' + tempCriteria.matchmaker_text + '</span></span>';
                    criteriaJSON['Matchmaker Text'] =  tempCriteria.matchmaker_text;
                } else {
                    htmlStr += '<span class="criteria"><span class="title">Search Text:</span> <span>' + tempCriteria.matchmaker_text.join(', ') + '</span></span>';
                    criteriaJSON['Matchmaker Text'] =  tempCriteria.matchmaker_text.join(', ');
                }
            }

            this.criteriaStr = htmlStr;
            // this.setExportCriteria(criteriaJSON);
            return this.criteriaStr;
        },
        showEditSearchCriteriaForm () {
            this.showCriteria = !this.showCriteria;
        },
        showAllCriteria () {
            this.showHideLinkText = this.showHideLinkText === 'More' ? 'Less' : 'More';
        },
        exportData(dataType) {
            this.$parent.$refs.Charts.export(dataType);
        },
        shareQuery (type) {
            var bodyMsg = 'Please click on link to view list of NIH-funded research projects ',
                mailText,
                subject = 'NIH RePORTER - Hitlist link';

            URL = location.href + (location.href.indexOf('?') !== -1 ? '&' : '?') + 'shared=true';
            this.$parent.saveSharedSearchID(type);
            switch (type) {
                case 'email':
                    switch (this.$route.name) {
                        case 'charts':
                            subject = 'NIH RePORTER - Hitlist visualization link';
                            break;
                        case 'publications':
                            subject = 'NIH RePORTER - Publication Hitlist link';
                            break;
                        case 'patents':
                            subject = 'NIH RePORTER - Patent Hitlist link';
                            break;
                        case 'clinicalStudies':
                            subject = 'NIH RePORTER - Clinical Studies Hitlist link';
                            break;
                    }

                    URL = URL.replace(/%/g, '%25').replace(/\&/g, '%26');
                    mailText = 'mailto:?subject=' + subject + '  &body=' + bodyMsg + ' %0A%0A ' + URL;

                    document.querySelector('#emailLinkHidden').setAttribute('href', mailText);
                    document.querySelector('#emailLinkHidden').click();

                    //GA
					gtag('event','Click', {
						'event_category': (this.$route.name === 'list' ? 'Search' : this.$route.name) + '  Results',
						'event_label': 'Email Link',
						'value': 'Email Link'
					});	
                    break;
                case 'copy':
                    try {
                        let reportLinkInput = document.createElement('input');

                        reportLinkInput.setAttribute('id', 'report-link');
                        reportLinkInput.value = URL;
                        reportLinkInput.style.opacity = '0';
                        document.body.appendChild(reportLinkInput);

                        reportLinkInput.select();
                        var successful = document.execCommand('copy');

                        reportLinkInput.remove();

                        if (successful) {
                            toast.success(`<strong>Success</strong>\nLink Copied`, {
                                autoClose: 2000, 
                                dangerouslyHTMLString: true,
                                closeButton: true,
                                pauseOnHover: false
                            });
                        }
                    } catch (err) {
                        // $('#copy-msg').html(('Oops, unable to copy'));
                    }
                    //GA
					gtag('event','Click', {
						'event_category': (this.$route.name === 'list' ? 'Search' : this.$route.name) + '  Results',
						'event_label': 'Copy Link',
						'value': 'Copy Link'
					});	
            }
        },
        search (changeCriteria, newSearch) {
            if (this.searchCriteria['smart_search_text']) {
                this.searchCriteria['smart_search_text'] = '';
            }

            var parsedCriteria = window.parseCriteria(this.searchCriteria, {isEditCriteria: false, isSubmitForm: true}),
                criteria = window.stringifySearchCriteriaFields(parsedCriteria, {});

            // if (!this.formHasErrors()) {
			gtag('event','Click', {
				'event_category': this.refpage ? 'Search Results' : 'Home',
				'event_label': 'Matchmaker Search - Submit',
				'value': 'Matchmaker Search - Submit'
			});

            this.loading = true;
            if (this.$parent && this.$parent.$refs && this.$parent.$refs.facets) {
                this.$parent.$refs.facets.facetLoader = true;
            }
            // this.$parent.$refs.navigationTabs.currentPath = 'matchmaker-projects'

            this.setEditSearchResultsFlag(false);
            this.$parent.resetCaptcha();

            this.$parent.clearSearchResults({resetFacets: true});
            this.$parent.criteriaChanged = changeCriteria; 
            if (this.$route.name === 'matchmaker-projects') {
                this.$parent.matchMakerListTable.isLoading = true;
                this.$parent.matchMakerListTable.sortField = 'match_score';
                this.$parent.matchMakerListTable.sortOrder = 'desc';
                this.$parent.setMatchmakerPOResults(null);
                this.$parent.getMatchmakerSearchResults(changeCriteria, newSearch, this.handleSearchResults);
            } else {
                this.$parent.POListTable.sortField = 'projects_counts';
                this.$parent.POListTable.sortOrder = 'desc';
                this.$parent.POListTable.isLoading = true;
                this.$parent.setMatchmakerResults(null);
                this.$parent.getMatchmakerPOResults(changeCriteria, newSearch, this.handlePOResults);
            }
        },
        handleSearchResults (data) {
            this.loading = false;
            this.$parent.matchMakerListTable.isLoading = false;
            this.$parent.$refs.facets.facetLoader = false;

            if (data && data.status && data.status !== HttpStatusCode.Ok) {
                if (data && data.status === HttpStatusCode.NoContent) { 
                    this.$parent.serviceErrorMessage = 'No concepts found.';
                    this.$parent.serviceError = 'Please try again using text containing scientific concepts from the NIH RCDC Thesaurus.';
                }
                else {
                    this.$parent.serviceErrorMessage = "";
                    this.$parent.serviceError = this.externalURLs.reporter_project_search_error_message;
                }
                this.$parent.setSearchMeta(null);
                this.$parent.setMatchmakerResults(null);
                return false;
            } else if (!data) {
                    this.$parent.serviceError = this.externalURLs.reporter_project_search_error_message;
            } else {
                this.$parent.criteriaChanged= false;
                if (data && data.meta && data.results) {
                    var url = '/matchmaker/';
                    this.$parent.setSearchMeta(data.meta);
                    this.$parent.setMatchmakerResults(data);

                    // default to Project results
                    url += data.meta.search_id + '/projects';

                    localStorage.setItem('matchmakerSearchText' + data.meta.search_id, this.searchCriteria.matchmaker_text);

                    if (this.$parent.sortField) {
                        url += '&sort_field=' + this.$parent.sortField + '&sort_order=' + this.$parent.sortOrder;
                    }
                    this.$router.push(url).catch(err => {});

                    this.$parent.$refs.dataTable.initTableData();
                    this.$parent.$refs.facets.getMatchmakerFacets(false);
                    this.$parent.getMatchmakerProjectsChartData();
                }
            }
        },
        handlePOResults (data) {
            this.loading = false;
            this.$parent.POListTable.isLoading = false;
            this.$parent.$refs.facets.facetLoader = false;

            if (data && data.status && data.status !== HttpStatusCode.Ok) {
                if (data && data.status === HttpStatusCode.NoContent) {
                    this.$parent.serviceErrorMessage = 'No concepts found.';
                    this.$parent.serviceError = 'Please try again using text containing scientific concepts from the NIH RCDC Thesaurus.';
                }
                else {
                    this.$parent.serviceErrorMessage = "";
                    this.$parent.serviceError = this.externalURLs.reporter_project_search_error_message;
                }
                this.$parent.setSearchMeta(null);
                this.$parent.setMatchmakerPOResults(null);
                return false;
            } else if (!data) {
              this.$parent.serviceError = this.externalURLs.reporter_project_search_error_message;
            } else {
                this.$parent.criteriaChanged= false;
                if (data && data.meta && data.results) {
                    var url = '/matchmaker/';
                    this.$parent.setSearchMeta(data.meta);
                    this.$parent.setMatchmakerPOResults(data);

                    // default to Project results
                    url += data.meta.search_id + '/POs';

                    localStorage.setItem('matchmakerSearchText' + data.meta.search_id, this.searchCriteria.matchmaker_text);

                    if (this.$parent.sortField) {
                        url += '&sort_field=' + this.$parent.sortField + '&sort_order=' + this.$parent.sortOrder;
                    }
                    this.$router.push(url).catch(err => {});

                    this.$parent.$refs.dataTable.initTableData();
                    this.$parent.$refs.facets.getMatchmakerFacets(false);
                    this.$parent.getMatchmakerProjectsChartData();
                }
            }
        },
        handleInputEvent (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                //submit search
                this.search(true, true);
            }
        },
    }

}
</script>

<style lang="scss" scoped>
@import 'node_modules/bootstrap/scss/_functions';
@import 'node_modules/bootstrap/scss/_variables';
@import '@/scss/variables.scss';
@import 'node_modules/bootstrap/scss/_mixins';

    .btn-primary {
        @include button-variant($orange-dark, $orange-dark);
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
    }

    .input-text__input {
        box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
    }

    .feature-area {
        .search-criteria-section {
            vertical-align: top;
            position: relative;
            display: block;
            width: 100%;
            .matchmaker-search {
                padding-right: calc(8em + 2rem + 10px);

                textarea {
                    font-size: 14px;
                    // border-bottom-right-radius: 0;
                }
                button {
                    position: absolute;
                    right: 0px;
                    // left: calc(100% + 10px);
                    bottom: 0;
                    min-width: 8em;
                    // border-top-left-radius: 0;
                    // border-bottom-left-radius: 0;
                }
            }
        }
    }

</style>
